(function () {
  'use strict';
  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }
  function initUpsell() {
    var scroll = document.getElementById('CartDrawer-UpsellScroll');
    if (!scroll) return;
    var cards = Array.from(scroll.querySelectorAll('.reina-upsell-card'));
    if (!cards.length) return;
    cards.forEach(function (c) { c.style.display = 'none'; });
    shuffle(cards).slice(0, 4).forEach(function (c) { c.style.display = 'flex'; });
    attachButtons();
  }
  function attachButtons() {
    document.querySelectorAll('#CartDrawer-UpsellScroll .reina-upsell-add').forEach(function (btn) {
      if (btn._reinaUpsell) return;
      btn._reinaUpsell = true;
      btn.addEventListener('click', function () {
        var variantId = this.getAttribute('data-variant-id');
        var card = this.closest('.reina-upsell-card');
        var self = this;
        self.disabled = true;
        self.textContent = '...';
        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        }).then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) { self.disabled = false; self.textContent = '+ הוסף לסל'; }
            else { card.style.opacity = '0.5'; self.textContent = '✓ נוסף'; }
          }).catch(function () { self.disabled = false; self.textContent = '+ הוסף לסל'; });
      });
    });
  }
  var _timer;
  function debouncedInit() { clearTimeout(_timer); _timer = setTimeout(initUpsell, 80); }
  function watchAndInit() {
    initUpsell();
    var drawerItems = document.querySelector('cart-drawer-items');
    if (!drawerItems) return;
    new MutationObserver(debouncedInit).observe(drawerItems, { childList: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchAndInit);
  } else {
    watchAndInit();
  }
})();
